<script>
import menuMixins from './menuMixins'
// import ICON_PAGE from '../../assets/img/page.svg'
// import ICON_PAGE1 from '../../assets/img/page_active.svg'
// import ICON_OBJECT from '../../assets/img/object.svg'
// import ICON_OBJECT1 from '../../assets/img/object_active.svg'
// import ICON_SERVICE from '../../assets/img/service.svg'
// import ICON_SERVICE1 from '../../assets/img/service_active.svg'
// import ICON_NAV from '../../assets/img/nav.svg'
// import ICON_NAV1 from '../../assets/img/nav_active.svg'
// import ICON_SERVICE_ARRANGE from '../../assets/img/service-arrange.svg'
// import ICON_SERVICE_ARRANGE1 from '../../assets/img/service-arrange_active.svg'
import MenuItem from './MenuItem'

export default {
    mixins: [menuMixins],
    data() {
        return {
        }
    },
    computed: {
        menus() {
            return Object.freeze([
                {
                    title: '业务对象',
                    activePaths: ['/object'],
                    // icon: ICON_OBJECT,
                    // activeIcon: ICON_OBJECT1,
                    route: '/object',
                    // showTenant: false,
                },
                {
                    title: '业务操作',
                    activePaths: ['/service'],
                    // icon: ICON_SERVICE,
                    // activeIcon: ICON_SERVICE1,
                    route: '/service',
                    // showTenant: false,
                },
                {
                    title: '页面设计',
                    activePaths: ['', '/'],
                    // icon: ICON_PAGE,
                    // activeIcon: ICON_PAGE1,
                    route: '/design',
                },
                {
                    title: '导航设置',
                    activePaths: ['/nav'],
                    // icon: ICON_NAV,
                    // activeIcon: ICON_NAV1,
                    route: '/nav',
                    hide: this.isTenant,
                },
                {
                    title: '应用设置',
                    activePaths: ['/setting'],
                    // icon: ICON_SERVICE_ARRANGE,
                    // activeIcon: ICON_SERVICE_ARRANGE1,
                    route: '/setting',
                },
            ])
        },
    },
    methods: {
    },
    render() {
        const {
            defaultActive, menus,
        } = this
        return (
            <hc-menu
                default-active={defaultActive}
                class="app-menu"
                router
                mode="horizontal"
            >
                {
                    menus.filter(menu => !menu.hide).map(item => (
                        <MenuItem key={item.title} data={item} />
                    ))
                }
            </hc-menu>
        )
    },
}
</script>

<style lang="less" scoped>
@import './common.less';
.app-menu{
    height: 52px;
    background: transparent;
    &.hc-menu {
        border: none;
    }
    &.hc-menu--horizontal .hc-menu-item {
        border: none;
        font-size: 12px;
        color: #E9EBEE;
        &:hover,
        &:focus {
            color: #FFFFFF;
            background: rgba(0,0,0,0.2);
        }
        &.is-true-active {
            position: relative;
            color: #FFFFFF;
            background: rgba(0,0,0,0.2);
            box-shadow: inset -1px 0 0 0 rgba(0,0,0,0.1), inset 1px 0 0 0 rgba(0,0,0,0.1);
            &:after {
                content: "";
                width: 100%;
                height: 4px;
                display: block;
                border-radius: 4px;
                background: #507AFE;
                transform: translateX(-50%);
                position: absolute;
                bottom: 0;
                left: 50%;
            }
        }
    }
    &.hc-menu--horizontal > .hc-menu-item {
        line-height: 52px;
        height: 100%;
    }
}
</style>
